import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../../context/LanguageContext';
import './StepNavC.css';

// 모듈C 프로세스 흐름: 2스테이지 = 2화면
// (권고 생성·승인은 화면1에서 확인 모달로 처리)
export const MODULE_C_STAGES = [
  { stage: 1, screen: 1, path: '/module-c/recommend', key: 'recommend' },
  { stage: 2, screen: 2, path: '/module-c/safeguard', key: 'safeguard' },
];

function StepNavC({ current }) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="mc-stepnav">
      <div className="mc-stepnav-brand">
        <span className="material-symbols-outlined mc-stepnav-brand-icon">precision_manufacturing</span>
        <div className="mc-stepnav-brand-text">
          <div className="mc-stepnav-brand-title">{t('pages.modulec.nav.brandTitle')}</div>
          <div className="mc-stepnav-brand-sub">{t('pages.modulec.nav.brandSub')}</div>
        </div>
      </div>

      <div className="mc-stepnav-steps">
        {MODULE_C_STAGES.map((s, idx) => {
          const state = s.screen === current ? 'active' : s.screen < current ? 'done' : 'todo';
          return (
            <React.Fragment key={s.stage}>
              <button
                type="button"
                className={`mc-step mc-step-${state}`}
                onClick={() => navigate(s.path)}
              >
                <span className="mc-step-circle">
                  {s.screen < current ? (
                    <span className="material-symbols-outlined mc-step-check">check</span>
                  ) : (
                    s.stage
                  )}
                </span>
                <span className="mc-step-labels">
                  <span className="mc-step-title">{t(`pages.modulec.nav.steps.${s.key}.title`)}</span>
                  <span className="mc-step-desc">{t(`pages.modulec.nav.steps.${s.key}.desc`)}</span>
                </span>
              </button>
              {idx < MODULE_C_STAGES.length - 1 && (
                <span className={`mc-step-connector ${s.screen < current ? 'filled' : ''}`}>
                  <span className="material-symbols-outlined">arrow_forward</span>
                </span>
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}

export default StepNavC;
